var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          ref: "modal",
          attrs: {
            id: "share-proof-from-fb",
            "modal-class": "share-image-proof-modal",
            "content-class": "share-image-proof-modal__content",
            "body-class": "share-image-proof-modal__body",
            "hide-header": "",
            "hide-footer": "",
            centered: "",
            "no-close-on-backdrop": "",
          },
          on: { show: _vm.onShow, hide: _vm.onHide },
        },
        [
          _c("div", { staticClass: "share-image-proof-modal__panel" }, [
            _c("div", { staticClass: "share-image-proof-modal__header" }, [
              _c("h2", { staticClass: "share-image-proof-modal__title" }, [
                _vm._v("\n          Share Proof\n        "),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "share-image-proof-modal__close",
                  attrs: {
                    type: "button",
                    "aria-label": "Close",
                    disabled: _vm.isSharing,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "aria-hidden": "true",
                      },
                    },
                    [
                      _c("path", { attrs: { d: "M18 6 6 18" } }),
                      _vm._v(" "),
                      _c("path", { attrs: { d: "m6 6 12 12" } }),
                    ]
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c(
              "fieldset",
              {
                staticClass: "share-image-proof-modal__fields",
                class: {
                  "share-image-proof-modal__fields--locked": _vm.formLocked,
                },
                attrs: {
                  disabled: _vm.formLocked,
                  "aria-busy": _vm.isSharing ? "true" : "false",
                },
              },
              [
                _c("div", { staticClass: "share-image-proof-modal__field" }, [
                  _c(
                    "label",
                    {
                      staticClass: "share-image-proof-modal__label",
                      attrs: { for: "share-image-proof-layout-name" },
                    },
                    [_vm._v("Layout name")]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.layoutName,
                        expression: "layoutName",
                      },
                    ],
                    staticClass: "share-image-proof-modal__input",
                    attrs: {
                      id: "share-image-proof-layout-name",
                      type: "text",
                      placeholder: "Layout name",
                      disabled: _vm.formLocked,
                    },
                    domProps: { value: _vm.layoutName },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.layoutName = $event.target.value
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("label", { staticClass: "share-image-proof-modal__check" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.notifyActivity,
                        expression: "notifyActivity",
                      },
                    ],
                    attrs: { type: "checkbox", disabled: _vm.formLocked },
                    domProps: {
                      checked: Array.isArray(_vm.notifyActivity)
                        ? _vm._i(_vm.notifyActivity, null) > -1
                        : _vm.notifyActivity,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.notifyActivity,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.notifyActivity = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.notifyActivity = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.notifyActivity = $$c
                        }
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "share-image-proof-modal__check-box",
                      attrs: { "aria-hidden": "true" },
                    },
                    [
                      _c(
                        "svg",
                        {
                          staticClass: "share-image-proof-modal__check-icon",
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "16",
                            height: "16",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                        },
                        [_c("path", { attrs: { d: "M20 6 9 17l-5-5" } })]
                      ),
                    ]
                  ),
                  _vm._v("\n          Notify me of proof activity\n        "),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "share-image-proof-modal__notify-others" },
                  [
                    _c(
                      "label",
                      { staticClass: "share-image-proof-modal__check" },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.notifyOthers,
                              expression: "notifyOthers",
                            },
                          ],
                          attrs: { type: "checkbox", disabled: _vm.formLocked },
                          domProps: {
                            checked: Array.isArray(_vm.notifyOthers)
                              ? _vm._i(_vm.notifyOthers, null) > -1
                              : _vm.notifyOthers,
                          },
                          on: {
                            change: function ($event) {
                              var $$a = _vm.notifyOthers,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.notifyOthers = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.notifyOthers = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.notifyOthers = $$c
                              }
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "share-image-proof-modal__check-box",
                            attrs: { "aria-hidden": "true" },
                          },
                          [
                            _c(
                              "svg",
                              {
                                staticClass:
                                  "share-image-proof-modal__check-icon",
                                attrs: {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  width: "16",
                                  height: "16",
                                  viewBox: "0 0 24 24",
                                  fill: "none",
                                  stroke: "currentColor",
                                  "stroke-width": "2",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                },
                              },
                              [_c("path", { attrs: { d: "M20 6 9 17l-5-5" } })]
                            ),
                          ]
                        ),
                        _vm._v("\n            Notify others…\n          "),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.notifyOthers
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "share-image-proof-modal__notify-others-body",
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.emailDraft,
                                  expression: "emailDraft",
                                },
                              ],
                              staticClass: "share-image-proof-modal__input",
                              attrs: {
                                type: "text",
                                placeholder: "Add email addresses",
                                disabled: _vm.formLocked,
                              },
                              domProps: { value: _vm.emailDraft },
                              on: {
                                keydown: _vm.onEmailKeydown,
                                blur: _vm.commitEmailDraft,
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.emailDraft = $event.target.value
                                },
                              },
                            }),
                            _vm._v(" "),
                            _vm.notifyOthersEmails.length
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "share-image-proof-modal__chips",
                                  },
                                  _vm._l(
                                    _vm.notifyOthersEmails,
                                    function (email) {
                                      return _c(
                                        "span",
                                        {
                                          key: email,
                                          staticClass:
                                            "share-image-proof-modal__chip",
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(email) +
                                              "\n                "
                                          ),
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "share-image-proof-modal__chip-remove",
                                              attrs: {
                                                type: "button",
                                                "aria-label": `Remove ${email}`,
                                                disabled: _vm.formLocked,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.removeEmail(email)
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "svg",
                                                {
                                                  attrs: {
                                                    xmlns:
                                                      "http://www.w3.org/2000/svg",
                                                    width: "12",
                                                    height: "12",
                                                    viewBox: "0 0 24 24",
                                                    fill: "none",
                                                    stroke: "currentColor",
                                                    "stroke-width": "2",
                                                    "stroke-linecap": "round",
                                                    "stroke-linejoin": "round",
                                                    "aria-hidden": "true",
                                                  },
                                                },
                                                [
                                                  _c("path", {
                                                    attrs: { d: "M18 6 6 18" },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("path", {
                                                    attrs: { d: "m6 6 12 12" },
                                                  }),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                )
                              : _vm._e(),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _c("label", { staticClass: "share-image-proof-modal__check" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.requestApproval,
                        expression: "requestApproval",
                      },
                    ],
                    attrs: { type: "checkbox", disabled: _vm.formLocked },
                    domProps: {
                      checked: Array.isArray(_vm.requestApproval)
                        ? _vm._i(_vm.requestApproval, null) > -1
                        : _vm.requestApproval,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.requestApproval,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.requestApproval = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.requestApproval = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.requestApproval = $$c
                        }
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "share-image-proof-modal__check-box",
                      attrs: { "aria-hidden": "true" },
                    },
                    [
                      _c(
                        "svg",
                        {
                          staticClass: "share-image-proof-modal__check-icon",
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "16",
                            height: "16",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                        },
                        [_c("path", { attrs: { d: "M20 6 9 17l-5-5" } })]
                      ),
                    ]
                  ),
                  _vm._v("\n          Request approval\n        "),
                ]),
                _vm._v(" "),
                _c("label", { staticClass: "share-image-proof-modal__check" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.shareRecentOnly,
                        expression: "shareRecentOnly",
                      },
                    ],
                    attrs: { type: "checkbox", disabled: _vm.formLocked },
                    domProps: {
                      checked: Array.isArray(_vm.shareRecentOnly)
                        ? _vm._i(_vm.shareRecentOnly, null) > -1
                        : _vm.shareRecentOnly,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.shareRecentOnly,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.shareRecentOnly = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.shareRecentOnly = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.shareRecentOnly = $$c
                        }
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "share-image-proof-modal__check-box",
                      attrs: { "aria-hidden": "true" },
                    },
                    [
                      _c(
                        "svg",
                        {
                          staticClass: "share-image-proof-modal__check-icon",
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "16",
                            height: "16",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                        },
                        [_c("path", { attrs: { d: "M20 6 9 17l-5-5" } })]
                      ),
                    ]
                  ),
                  _vm._v(
                    "\n          Share most recent version only\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("label", { staticClass: "share-image-proof-modal__check" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.dailyReminder,
                        expression: "dailyReminder",
                      },
                    ],
                    attrs: { type: "checkbox", disabled: _vm.formLocked },
                    domProps: {
                      checked: Array.isArray(_vm.dailyReminder)
                        ? _vm._i(_vm.dailyReminder, null) > -1
                        : _vm.dailyReminder,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.dailyReminder,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.dailyReminder = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.dailyReminder = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.dailyReminder = $$c
                        }
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "share-image-proof-modal__check-box",
                      attrs: { "aria-hidden": "true" },
                    },
                    [
                      _c(
                        "svg",
                        {
                          staticClass: "share-image-proof-modal__check-icon",
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "16",
                            height: "16",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                        },
                        [_c("path", { attrs: { d: "M20 6 9 17l-5-5" } })]
                      ),
                    ]
                  ),
                  _vm._v(
                    "\n          Send daily reminders for unresolved comments\n        "
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _vm.proofUrl
              ? _c("div", { staticClass: "share-image-proof-modal__link" }, [
                  _c(
                    "label",
                    { staticClass: "share-image-proof-modal__label" },
                    [_vm._v("Share a link")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "share-image-proof-modal__link-row" },
                    [
                      _c("input", {
                        ref: "copyTarget",
                        staticClass: "share-image-proof-modal__link-input",
                        attrs: { readonly: "" },
                        domProps: { value: _vm.proofUrl },
                        on: { click: _vm.copyLink },
                      }),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "share-image-proof-modal__icon-btn",
                          attrs: {
                            type: "button",
                            title: "Copy link",
                            "aria-label": "Copy link",
                          },
                          on: { click: _vm.copyLink },
                        },
                        [_c("i", { staticClass: "fa fa-clipboard" })]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "share-image-proof-modal__icon-btn",
                          attrs: {
                            href: _vm.proofUrl,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            title: "Open link",
                            "aria-label": "Open link",
                          },
                        },
                        [_c("i", { staticClass: "fa fa-external-link-alt" })]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.copied
                    ? _c(
                        "p",
                        { staticClass: "share-image-proof-modal__copied" },
                        [
                          _vm._v(
                            "\n          Link copied to clipboard!\n        "
                          ),
                        ]
                      )
                    : _vm._e(),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "share-image-proof-modal__footer" }, [
              _c(
                "button",
                {
                  staticClass: "share-image-proof-modal__btn-cancel",
                  attrs: { type: "button", disabled: _vm.isSharing },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.proofUrl ? "Close" : "Cancel") +
                      "\n        "
                  ),
                ]
              ),
              _vm._v(" "),
              !_vm.proofUrl
                ? _c(
                    "button",
                    {
                      staticClass: "share-image-proof-modal__btn-share",
                      attrs: {
                        type: "button",
                        disabled: !_vm.shareAvailable || _vm.isSharing,
                      },
                      on: { click: _vm.handleOkBtn },
                    },
                    [
                      _vm.isSharing
                        ? _c("b-spinner", { attrs: { small: "" } })
                        : _vm._e(),
                      _vm._v("\n          Share Proof\n        "),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }